import Icon from '@/components/snippets/icon/icon'
import { useEffect, useRef } from 'preact/hooks'

export function FilterCollapse({ label, children, activeFilterLabel, valueType = 'default' }) {
  const id = `filter-${label.toLowerCase().replace(/\s/g, '-')}`
  const modalRef = useRef(null)
  const isSortAccordion = id === 'filter-sort'

  useEffect(() => {
    const modal = modalRef.current
    if (!modal) return

    if (isSortAccordion) {
      const handleOpen = () => {
        if (modal.dataset.ui !== 'visible') {
          modal.handleToggle?.()
        }
      }
      const handleClose = () => {
        if (modal.dataset.ui === 'visible') {
          modal.handleToggle?.()
        }
      }

      window.addEventListener('searchspring:open-sort-accordion', handleOpen)
      window.addEventListener('searchspring:close-sort-accordion', handleClose)
      return () => {
        window.removeEventListener('searchspring:open-sort-accordion', handleOpen)
        window.removeEventListener('searchspring:close-sort-accordion', handleClose)
      }
    } else {
      const handleClose = () => {
        if (modal.dataset.ui === 'visible') {
          modal.handleToggle?.()
        }
      }

      window.addEventListener('searchspring:close-filter-accordions', handleClose)
      return () => window.removeEventListener('searchspring:close-filter-accordions', handleClose)
    }
  }, [isSortAccordion])

  return (
    <x-modal
      ref={modalRef}
      data-id={id}
      className="group/filter flex flex-col border-b border-neutral-medium dropdown-modal"
      data-toggle-group="true"
    >
      <button
        className="flex min-h-[56px] items-center justify-between gap-x-0.75 px-1 py-1 text-left link-fade md:px-1.5"
        data-modal-parent={id}
        data-modal-role="toggle"
        aria-label={label}
      >
        <span className="h5 flex flex-wrap items-center">
          <span>{label}</span>
          {activeFilterLabel ? (
            valueType === 'number' ? (
              <span className="paragraph-s ml-0.5 flex aspect-1/1 w-[20px] items-center justify-center rounded-full bg-brand-neutral text-center font-medium !leading-none text-brand-black">
                {activeFilterLabel}
              </span>
            ) : (
              <span>
                : <span className="text-neutral-secondary">{activeFilterLabel}</span>
              </span>
            )
          ) : null}
        </span>
        <div
          className={'flex h-[8px] w-[14px] transition-all group-data-visible/filter:-rotate-180 children:size-full'}
        >
          <Icon id="chevron-down" />
        </div>
      </button>
      <div className="dropdown-content">
        <div className="overflow-hidden flex flex-col">{children}</div>
      </div>
    </x-modal>
  )
}
